import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "../../api-utility/axiosInstance";

// FETCH ALL ORGANIZATIONS
export const fetchAllOrganizations = createAsyncThunk(
  "organization/fetchAll",
  async (params, { rejectWithValue }) => {
    try {
      const response = await Axios.get("/tenant/organizations", { params });
      return response.data?.data || [];
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch organizations",
      );
    }
  },
);

const organizationSlice = createSlice({
  name: "organization",
  initialState: {
    organizations: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllOrganizations.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAllOrganizations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organizations = action.payload;
      })
      .addCase(fetchAllOrganizations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default organizationSlice.reducer;
